import { Address } from '@/types';
import axios from 'axios';

// zipcloud は該当する住所が無いとき results に null を返す。呼び出し元が results の
// 形を意識しなくて済むよう、ここで「見つからなければ null」に正規化する
type ZipcloudResponse = {
  message: string;
  results: Array<Address> | null;
};

export const findAddressByZip = async (
  zip: string
): Promise<Address | null> => {
  const response = await axios.get<ZipcloudResponse>(
    `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zip}`
  );
  return response.data.results?.[0] ?? null;
};
